export const PEO_ID = 'peo_id';
export const SSO_KEY = 'key';
export const ACCESS_TOKEN = 'access_token';
export const USER_NAME = 'userName';
export const EMPlOYEE_ID = 'employeeId';
export const CLIENTS = 'clients';
export const MFA_VERIFY = 'mfa_verify';

